<div id="cl-wrapper" class="login-container login-theme padding-50">
  <div class="block-flat">
    <div class="header">
      <h3>
        <i class="fas fa-exclamation-triangle"></i>
        {{'GLOBAL_ERROR_PAGE_TITLE'|translate}}
      </h3>
    </div>
    <div>
      <div class="form-horizontal">
        <div class="content">
          <h5 class="color-default" style="margin: 0 0 25px;">
            <span class="full-width" *ngIf="styleError">
              <strong><em>{{'ERROR_CONNECTION_OR_CACHE'|translate}}<br /><br /></em></strong>
            </span>
            {{'GLOBAL_ERROR_PAGE_SUBTITLE'|translate}}
          </h5>

          <div class="alert alert-danger" *ngIf="message.length > 0">
            <div class="col-md-12 margin-bottom-15" *ngIf="returnUrl">
              <span class="full-width">
                <strong><em>{{returnUrl}}</em></strong>
              </span>
            </div>

            <div class="col-md-12">
              <span class="full-width white-space-preserved">{{message}}</span>
            </div>
          </div>
        </div>
        <div class="foot">
          <button type="button" class="btn btn-default no-min-width" title="{{'COPY' | translate}}"
            (click)="copyToClipboard()">
            <i class="far fa-copy"></i>
          </button>

          <a [href]="mailTo" target="_blank" class="btn btn-default no-min-width" title="{{'SEND_EMAIL' | translate}}"
            *ngIf="mailTo">
            <i class="fas fa-paper-plane"></i>
          </a>

          <button type="button" class="btn btn-primary" title="{{'BACK_TO_PORTAL' | translate}}"
            (click)="returnToPortal()">
            <i class="fas fa-arrow-left"></i>&nbsp;{{'BACK_TO_PORTAL' | translate}}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>